import { Interfaces } from "@/core/Export";

export namespace Models {

  export class AttendMulitpleReportEntryDto {
    employeeIds: Array<any> = new Array<any>();
    fromDate: string = "";
    toDate: string = "";
    canEnterSpecialDates: boolean = false;
    lines: Array<AttendMulitpleReportEntryLineDto> = [];
  }

  export class AttendMulitpleReportEntryLineDto {
    toSave: boolean = false;
    toDelete: boolean = false;
    dayOfWeek: number = 0;
    dayTypeCode: string = "";
    dayName: string = "";
    specialDate: string = "";
    entryTimeText: string = "";
    exitTimeText: string = "";
    specialEventId: number = 0;
    notes: string = "";
  }

  export class BaseMissingEventReportEntry {
    missingEvents: Array<any> = new Array<any>()
    missingEventId: number
    fromDate
    toDate
    fromTimeText: string
    toTimeText: string
    isOverridePairs: boolean
    comment: string
    missingEventOption: number
    resultMsgs
  }

  export class MissingEventMulitpleReportEntry extends BaseMissingEventReportEntry {
    employeeIds: Array<any> = new Array<any>()
    replaceMissingEventId: number
  }

  export class PortalTeamLeaderEmployeesPunchInOutDto {
    constructor(timeZone: number, isExist: boolean, employeeIds: Array<number>) {
      this.timeZone = timeZone;
      this.isExit = isExist;
      this.employeesIds = employeeIds;
    }
    timeZone: number;
    isExit: boolean;
    employeesIds: Array<number>;

  }
  export class PortalLogDto {
    latitude: number;
    longitude: number;
    accuracy: number;
    isHealthDeclarationApproved: boolean;
    isHealthDeclarationFilledForToday: boolean;
    attendSpecialEventId: number;
    timeZone: number;
    additionalEmployeeId: number;
  }
  export class Reports {
    constructor() {
      this.employeeIds = new Array<any>();
      this.orgStructId = 0;
      this.year = 0;
      this.month = 0;
      this.salaryFactoryNo = null;
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDateStr = null;
      this.toDateStr = null;
      this.reportTypeCode = null;
      this.layoutId = 0;
      this.dynamicReportId = 0;
      this.sortBy = 0;
      this.thenBy = 0;
      this.dynamicSortBy = null;
      this.dynamicThenBy = null;
      this.dataHoursOrDays = null;
    }
    employeeIds: Array<any>;
    orgStructId: number = 0;
    year: number;
    month: number;
    salaryFactoryNo: string;
    fromDate: Date;
    toDate: Date;
    fromDateStr: string;
    toDateStr: string;
    reportTypeCode: string;
    layoutId: number;
    dynamicReportId: number;
    sortBy: number;
    thenBy: number;
    dynamicSortBy: any;
    dynamicThenBy: any;
    dataHoursOrDays: string;
  }
  export class EmployeePairsEntry {
    dayCommetId: number;
    pairId: number;
    dayName: string;
    dayOfWeek: number;
    isEditable: boolean;
    oldEntryTimeText: string;
    oldExitTimeText: string;
    isDeleted: boolean;
    isNew: boolean;
    entryLogId: number;
    exitLogId: number;
    date: string;
    notes: string;
    duration: number;
    missingEventRequestId: number;
    attendSpecialEventId: number;
    missingEventId: number;
    missingEventFileId: number;
    isAllDay: boolean;
    durationText: string;
    employeeId: number;
    orgStructId: number;
    entryLog: EmployeeEntryExitLog;
    exitLog: EmployeeEntryExitLog;
    actualDate: string;
    id: number;
    code: string;
    isActive: boolean;
    createdBy: string;
    createdOn: string;
    lastUpdateBy: string;
    version: string;
    key: string;
    stdTime: number;
    hasNotesError: boolean;
    isEntryFliped: boolean;
    hasEntryNotSingingReasonError: boolean;
    hasExitNotSingingReasonError: boolean;
    hasSpecialEventRequiredError: boolean;
    isFillTeken: boolean;
    standByData: EmployeeStandby
  }

  export class EmployeeEntryExitLog {
    dateTime: string;
    hasValue: string;
    employeeId: number;
    year: number;
    month: number;
    day: number;
    time: number;
    timeText: string;
    sourceCode: string;
    latitude: string;
    longitude: string;
    ipAdress: string;
    isExit: boolean;
    date: string;
    isManualEntry: boolean;
    notSingingReasonId: number;
    isExludeFromAttend: boolean;
    actionCode: number;
    badge: string;
    orgStructId: number;
    clockNo: string;
    missingEventRequestId: number;
    missingEventId: number;
    attendSpecialEventId: number;
    notes: string;
    isAllDay: boolean;
    missingEventExitLogId: number;
    missingEventFileId: number;
    stateCode: string;
    checkedBy: string;
    checkedDate: string;
    id: number;
    code: string;
    isActive: boolean;
    createdBy: string;
    createdOn: string;
    lastUpdateBy: string;
    version: string;
  }

  export class EAME_DayDto extends EmployeePairsEntry {
    pairs: Array<EAME_PairDto>;
    attendSpecialEvents: Array<any>;

  }

  export class EAME_PairDto extends EmployeePairsEntry { }

  export class MissingEvent {
    employeeId: number;
    fileIds: Array<number>;
    missingEvents: Array<any>;
    missingEventId: number;
    fromDate: string;
    toDate: string;
    fromTimeText: string;
    toTimeText: string;
    fromTime: number;
    toTime: number;
    isOverridePairs: boolean;
    comment: string;
    missingEventOption: number;
    isDeleteFiles: boolean;
    replaceMissingEventId: number;
    budgetItemId: number;
    forceSpecialEvent: boolean;
  }

  export class UserInfo {
    displayName: string = null;
    currentRole: string = null;
    accessToken: string = null;
    appVersion: string = null;
    applicationType: number = 0;
    customerCode: string = null;
    customerName: string = null;
    isFirstLogin: boolean = false;
    isSystemAdmin: boolean = false;
    isManager: boolean = false;
    permssions: Array<any> = new Array<any>();
    salaryFactoryNumbers: Array<any> = new Array<any>();
    lastLogin: string = null;
    employeeId: number = 0;
    availableMissingEventsIds: Array<any> = new Array<any>();
    availableReportTypesCodes: Array<any> = new Array<any>();
    showHealthDeclaration: boolean = false;
    approvals: Approvals = new Approvals();
    langCode: string = null;
    actingManagers: Array<any> = new Array<any>();
    isUseStrongPW: boolean = false;
    forceSpecialEvent: boolean = false;
    minutesToTerminateSessionAfterWithoutUsingSystem: number = 0;
    currentMonth: number;
    currentYear: number;
    additionalJobs: Array<any> = new Array<any>();
    isAdditionalJobsEnabled: boolean;
    primaryEmployeeId: number = 0;
    currentAttendYear: number;
    currentAttendMonth: number;
    isTeamLeaderReporting: boolean;
    isTeamLeaderReportEmp: boolean;
    numberActiveYears: number;
  }

  export class Approvals {
    hasApprovals: boolean = false;
    noOfApprovals: number = 0;
    hasManagerApprovals: boolean = false;
    noOfManagerApprovals: number = 0;
  }

  export class uiHeader {
    caption: string = "";
    icon: string = "";
    class: string = "";
    visible = true;
  }

  export class onPropertyChangeOptions {
    entityName: string = "";
    layoutCode: string = "";
    id: string = null;
    fieldName: string = "";
    newValue: any;
    formData: any;
  }

  export class formsLayouts {
    private _inner: Array<any>;

    constructor() {
      this._inner = new Array<any>();
    }

    public loadLayout(entityName: string) {
      let layout = this._inner.find((s) => s.Id == entityName);
    }
  }

  export class TBaseItem {
    id = 0;
    code = "";
    name = "";
  }

  export class ServiceCall implements Interfaces.iServiceCall {
    Id;
    methodName;
    parameters;
    callResult;
    isSuccess;
    msgs;

    constructor() { }
  }

  export class ServiceRequest implements Interfaces.iServiceRequest {
    calls: Array<Interfaces.iServiceCall>;
    recivedStamp;
    isSuccess;
    constructor() {
      this.calls = new Array<ServiceCall>();
    }

    addServiceCall(methodName: string, parameters?: any) {
      let call = new ServiceCall();
      call.methodName = methodName;
      call.parameters = parameters;
      this.calls.push(call);
    }
  }

  export class AppUtils {
    static formatTime(value: string) {
      if (!value) return "";
      let hours = 0;
      let minutes = 0;
      value = value.replace(/[$&+,:;=?@#|'<>.^*()%!-]/g, '')

      if (value.length == 1) {
        hours = parseInt(value);
      } else if (value.length == 2) {
        let test = parseInt(value);
        if (test < 24) {
          hours = test;
        }
      } else if (value.length == 3) {
        var str = value.slice(0, 1);
        hours = parseInt(str);
        str = value.slice(1, 3);
        minutes = parseInt(str);
      } else if (value.length == 4) {
        var str = value.slice(0, 2);
        hours = parseInt(str);
        str = value.slice(2, 4);
        minutes = parseInt(str);
      }

      if (hours === 0 && minutes === 0) return "";
      if (minutes > 60) minutes = 0;
      if (hours >= 24) hours = 0;
      let strH = this.formatTimePart(hours);
      let strM = this.formatTimePart(minutes);

      return strH + ":" + strM;
    }

    static calculateDuration(entryText: string, exitText: string) {
      if (!entryText && !exitText) return "";

      let start = new Models.time(entryText);
      let end = new Models.time(exitText);

      var minutes = 0;
      var hours = 0;

      if (end.hours > start.hours) {
        hours = end.hours - start.hours;
      } else {
        hours = 24 - start.hours + end.hours;
      }


      if (end.minutes < start.minutes) {
        hours = hours - 1;
        minutes = 60 + end.minutes - start.minutes;
      } else {
        minutes = end.minutes - start.minutes;
      }

      var strH = this.formatTimePart(hours);
      var strM = this.formatTimePart(minutes);

      if (hours >= 24) {
        strH = "00";
        if (minutes == 0) {
          strM = "00";
        }
      }

      return strH + ":" + strM;
    }

    static formatTimePart(value: number) {
      return value > 9 ? value.toString() : "0" + value.toString();
    }

    static getMinutes(value: string) {
      let time = new Models.time(value);
      return time.toMinutes;
    }

    static copyFromTo(target, source) {
      Object.assign(target, source);
    }

    static isObject(obj) {
      var type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }
  }

  export class time {
    private _hours: number;
    private _minutes: number;

    constructor(value: string) {
      if (value) {
        let h = value.slice(0, 2);
        let m = value.slice(3, 5);
        this._hours = parseInt(h);
        this._minutes = parseInt(m);
      } else {
        this._hours = 0;
        this._minutes = 0;
      }
    }

    public get hours() {
      return this._hours;
    }
    public get minutes() {
      return this._minutes;
    }

    public get toMinutes() {
      return this.hours * 60 + this.minutes;
    }

    fromMinutes(from: number) {
      this._hours = Math.floor(from / 60);
      this._minutes = from - this._hours * 60;
    }
  }

  export class EmployeeAdditionalPortal {
    employeeId: number;
    date: string;
    canEdit: boolean;
    additionals: EmployeeDayAdditionalPortalItemDto[];
  }

  export class EmployeeDayAdditionalPortalItemDto {
    systemCreatedName: string;
    hourTypeName: string;
    valueTypeName: string;
    reasonName: string;
    notes: string;
    lastUpdateBy: string;
    canEdit: string;
    calculatedByTheSystem: boolean;
    nominationName: string;
  }

  export class EmployeeExtra {
    id: number = -1;
    employeeId: number;
    userCreated: number;
    valueTypeCode: string = null;
    valueType: Array<any> = [];
    hourTypeId: number = 0;
    valueText: any = null;
    value: any;
    employeeDayAdditionalReasonId: number;
    notes: string = null;
    destinationFrom: string = null;
    destinationTo: string = null;
    nominationId: number = 0;
  }


  export class EmployeeStandby {
    employeeId: number;
    date: string;
    dayOfWeek: number;
    dayName: string;
    startTime: number;
    startTimeText: string;
    endTime: number;
    endTimeText: string;
    entryTimeText: string;
    exitTimeText: string;
    entrySourceCode: string;
    entryIsManual: boolean;
    exitSourceCode: string;
    exitIsManual: boolean;
    isFillTeken: boolean;
    eventName: string;
    notes: string;
    hasStartTimeError: boolean;
    hasEndTimeError: boolean;
  }


}